export function generateFacebook_link(page_id, page_link){
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;
  var device = "";
  var link = "";

  if (/windows phone/i.test(userAgent)) {
      device = "Desktop";
  }else if (/android/i.test(userAgent)) {
      device = "Android";
  }else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      device = "iOS";
  }else{
      device = "Desktop";
  }

  if(page_id !== "" && page_id !== null && page_id !== undefined){

    switch (device) {
      case "Android":
        link = `fb://page/${page_id}/`
        break;
    
      case "iOS":
        link = `fb://profile/${page_id}/`
        break;
    
      case "Desktop":
        link = `https://www.facebook.com/${page_id}/reviews`
        break;
    
      default:
        link = `https://www.facebook.com/${page_id}/reviews`
        break;
    }

  }else{

    if (page_link.includes("facebook")){
      page_link = page_link.replace("/reviews/", "")
      page_link = page_link.replace("/reviews", "")
      link = `${page_link}/reviews`
    }else{
      page_link = page_link.replace("/reviews/", "")
      page_link = page_link.replace("/reviews", "")
      link = `https://www.facebook.com/${page_link}/reviews`
    }

  }
    return link
}